/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_Add_New_NoteInputs */

const en_read_along_add_new_note = /** @type {(inputs: Read_Along_Add_New_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add New Note`)
};

const es_read_along_add_new_note = /** @type {(inputs: Read_Along_Add_New_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar nota nueva`)
};

/**
* | output |
* | --- |
* | "Add New Note" |
*
* @param {Read_Along_Add_New_NoteInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_add_new_note = /** @type {((inputs?: Read_Along_Add_New_NoteInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Add_New_NoteInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_add_new_note(inputs)
	return en_read_along_add_new_note(inputs)
});